import camelize from 'camelcase-keys'

import { isNil } from './isNil'

export const Objects = {
  camelize,
  isNil,
}
